var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_vm._v(" hash : "+_vm._s(_vm.hash)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }